// ─────────────────────────────────────────────────────────────────────────────
// 🔑 THE STEP LINE AND BAR ON EVERY BORROWER PAGE (Jesse/Hannah, 2026-11-02 — the Home Shopping page redesign). Replaces
// the blue 8-step tracker (AppShell's ProgressBar). The guided flow's own pieces: its step context (GuidedShell — "Step X
// of N" 13px, the name 18px/600, the bar 12px below) and GuidedProgress's segments (blue done, yellow current, grey
// upcoming), in the guided column (constants/guidedLayout). On the dashboard, "Welcome back, [first name]" sits above it
// (small, as in the guided flow). The stage → step map is constants/journeySteps (display only).
// ─────────────────────────────────────────────────────────────────────────────
import React from 'react';
import GuidedProgress from './guided/GuidedProgress';
import { guidedColumn } from '../constants/guidedLayout';
import { journeyStepFor, JOURNEY_COPY } from '../constants/journeySteps';

export default function JourneyHeader({ status, welcomeName = undefined }) {
  const j = journeyStepFor(status);
  if (!j) return null;
  return (
    <div data-testid="journey-header" data-step={j.step} className="px-4 sm:px-6" style={{ paddingTop: 20, paddingBottom: 4 }}>
      <div style={guidedColumn}>
        {welcomeName !== undefined && (
          <div data-testid="journey-welcome" style={{ fontSize: 13, color: '#000', marginBottom: 6 }}>{JOURNEY_COPY.welcome(welcomeName)}</div>
        )}
        <div data-testid="journey-step-line" style={{ fontSize: 13, color: '#000' }}>{JOURNEY_COPY.stepLine(j.step)}</div>
        <div data-testid="journey-step-name" style={{ fontSize: 18, fontWeight: 600, color: '#000', marginTop: 2 }}>{j.name}</div>
        <div style={{ marginTop: 12 }}>
          <GuidedProgress step={j.step} total={j.total} valueText={`${JOURNEY_COPY.stepLine(j.step)}, ${j.name}`} />
        </div>
      </div>
    </div>
  );
}
